import { FormikValues } from "formik"
import { FormikMultipleAutoComplete } from "../../../../../shared/components/forms/Formik"
import { StringKeyOf } from "../../../../../lib/lang"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { AllergensResponse, fetchAllergens } from "../productsApi"
import { Allergen } from "../productsTypes"

function transformData(data: AllergensResponse) {
    return data.allergens
}

export type AllergensOption = Allergen

type FormikAllergensFieldProps<Values extends FormikValues> = Readonly<{
    name: StringKeyOf<Values>
}>

export function FormikAllergensField<Values extends FormikValues>({ name }: FormikAllergensFieldProps<Values>) {
    const allergens = useApiQuery(fetchAllergens, {
        queryName: "allergens",
        dependencies: {},
        select: transformData,
    })

    return (
        <LocalizedStrict id="product-create-product-description-allergens-field" attrs={{ label: true }}>
            <FormikMultipleAutoComplete<Values, AllergensOption, AllergensOption>
                name={name}
                label="Allergens"
                disableCloseOnSelect
                options={allergens.data ?? []}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                areOptionsEqual={(x, y) => x.id === y.id}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option}
                fullWidth
            />
        </LocalizedStrict>
    )
}
